const sortStages = <T extends { sequence: number }>(stages: T[]): T[] => {
  return [...stages].sort((a, b) => {
    return a.sequence - b.sequence
  })
}

export { sortStages }
